<template>
  <BreadCrumb PageTitle="Gestion des dépenses" />
  <SpentsList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import SpentsList from "../../components/Spents/SpentsList.vue";

export default defineComponent({
  name: "SpentsListPage",
  components: {
    BreadCrumb,
    SpentsList,
  },
}); 
</script>